import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import userReducer from "redux/userList/userSlice";
import roleManagementReducer from "redux/roleManagement/roleManagementSlice";
import retroClaimReducer from "redux/retroClaim/retroClaimSlice";
import reimbursementSliceReducer from "redux/reimbursement/reimbursementSlice";

export const store = configureStore({
	reducer: {
		users: userReducer,
		roleManagement: roleManagementReducer,
		claimManagement: retroClaimReducer,
		reimbursement: reimbursementSliceReducer
	}
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
